import Color from '@base/features/game/model/color';

export enum LineOrientations {
  ORIENTATION_NORMAL,
  ORIENTATION_REVERSED,
}

export enum LineColors {
  COLOR_TRANSPARENT,
  COLOR_DARK_GREEN,
  COLOR_LIGHT_GREEN,
}

export enum LineStates {
  STATE_NORMAL,
  STATE_AVAILABLE,
  STATE_DRAG_OVER,
  STATE_UNDO,
}

export enum DiceColors {
  BLACK,
  WHITE,
  GRAY,
  GRAY_WHITE,
  GRAY_BLACK,
}

export type DoubleCubeData = {
  value: number;
  color?: Color;
  active: boolean;
};

export enum BackgammonPhases {
  UNKNOWN = 0,
  ACTIVATE = 501,
  CONTINUE = 502,
  DEACTIVATE = 503,
  FIRST_FROM_BAR = 504,
  NO_ANY_MOVE = 505,
  STOP = 506,
  WAIT_FOR_OP = 507,
  WANT_TO_START = 508,
  WATCHER = 509,
  SHOW_SCORE = 510,
  CONTINUE1 = 511,
  WAIT_FOR_OP1 = 512,
}

export enum BackgammonScoreTypes {
  LAST = 1,
  FULL,
  FULL_REV,
}
